import {createContext} from 'react';

import type {SizesVariantsTypes} from '@pb/kit-component-avatar';
import type {Context} from 'react';

const DEFAULT_CONTEXT = {size: undefined};

export type ContextType = {
    size?: SizesVariantsTypes,
};

export const AvatarGroupContext: Context<ContextType> = createContext<ContextType>(DEFAULT_CONTEXT);
AvatarGroupContext.displayName = 'AvatarGroupContext';
